import {
  surfTokenEthContract,
  surfTokenBscContract,
  surfTokenXDaiContract,
  surfTokenMaticContract,
} from './contracts';
import { EthProvider, BscProvider, XDaiProvider, MaticProvider } from './providers';
import { ChainData, ChainId, Token } from './types';

export const DEFAULT_CHAIN = ChainId.EthMainnet;

export const ALL_CHAINS = [
  ChainId.EthMainnet,
  ChainId.XDai,
  ChainId.BscMainnet,
  ChainId.MaticMainnet,
];

export const CHAIN_DATA_MAPPING: Record<ChainId, ChainData> = {
  [ChainId.EthMainnet]: {
    id: ChainId.EthMainnet,
    displayName: 'Ethereum Mainnet',
    shortDisplayName: 'Ethereum',
    styleSlug: 'eth',
    color: '#17629A',
    colorLight: '#B8DAF4',
    colorDark: '#11436A',
    explorerUrl: 'https://etherscan.io/address/{{account}}',
    exchangeUrl: `https://app.uniswap.org/#/swap?outputCurrency=${Token.ETH_SURF}`,
    provider: EthProvider,
    surfTokenContract: surfTokenEthContract,
  },
  [ChainId.BscMainnet]: {
    id: ChainId.BscMainnet,
    displayName: 'Binance Smart Chain',
    shortDisplayName: 'BSC',
    styleSlug: 'bsc',
    color: '#D0980F',
    colorLight: '#FAE6B3',
    colorDark: '#725408',
    explorerUrl: 'https://bscscan.com/address/{{account}}',
    exchangeUrl: `https://exchange.pancakeswap.com/#/swap?outputCurrency=${Token.BSC_SURF}`,
    provider: BscProvider,
    surfTokenContract: surfTokenBscContract,
  },
  [ChainId.XDai]: {
    id: ChainId.XDai,
    displayName: 'xDai STAKE',
    shortDisplayName: 'xDai',
    styleSlug: 'xdai',
    color: '#4AA9A5',
    colorLight: '#C6E6E5',
    colorDark: '#255553',
    explorerUrl: 'https://blockscout.com/xdai/mainnet/address/{{account}}',
    exchangeUrl: `https://app.honeyswap.org/#/swap?outputCurrency=${Token.XDAI_SURF}`,
    provider: XDaiProvider,
    surfTokenContract: surfTokenXDaiContract,
  },
  [ChainId.MaticMainnet]: {
    id: ChainId.MaticMainnet,
    displayName: 'Polygon (Matic)',
    shortDisplayName: 'Polygon',
    styleSlug: 'polygon',
    color: '#8147E5',
    colorLight: '#CEB8F5',
    colorDark: '#310F6B',
    explorerUrl: 'https://polygonscan.com/address/{{account}}',
    exchangeUrl: `https://quickswap.exchange/#/swap?outputCurrency=${Token.MATIC_SURF}`,
    provider: MaticProvider,
    surfTokenContract: surfTokenMaticContract,
  },
};

export const EMPTY_CHAIN_AMOUNTS: Record<ChainId, number> = {
  [ChainId.EthMainnet]: 0,
  [ChainId.BscMainnet]: 0,
  [ChainId.XDai]: 0,
  [ChainId.MaticMainnet]: 0,
};

export const HONEYSWAP_SUBGRAPH_PATH = 'https://api.thegraph.com/subgraphs/name/1hive/honeyswap-v2';
export const QUICKSWAP_SUBGRAPH_PATH =
  'https://api.thegraph.com/subgraphs/name/sameepsi/quickswap06';
export const UNISWAP_SUBGRAPH_PATH = 'https://api.thegraph.com/subgraphs/name/uniswap/uniswap-v2';

export const POLYGON_TREASURY_ACCOUNT = '0xde4c22d69afe3c49ca3acad20bb4777eb5aebd75';
